// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

enum InvitationView {
  EmailInvitation = 'email-invitation',
  AsyncEnrollmentRequest = 'async-enrollment-request',
}

export { InvitationView };
